import uuid from 'uuid/v4';
import { DiffMatchPatch } from '../../utils/diff-match-patch/diff-match-patch';
export const getDiffObjectsBetweenParagraphs = (paragraphsA, paragraphsB) => {
  const diffObjects = [];
  paragraphsA.forEach((promise, index) => {
    const paragraph = paragraphsA[index];
    const a = DiffMatchPatch.diff_linesToWords_(paragraph.text, paragraphsB[index].text);
    let lineText1 = a.chars1;
    let lineText2 = a.chars2;
    let lineArray = a.lineArray;
    const diffs = DiffMatchPatch.diff_main(lineText1, lineText2, false);
    DiffMatchPatch.diff_charsToLines_(diffs, lineArray);
    let offset = paragraph.from;
    for (let i = 0; i < diffs.length; i++) {
      const diff = diffs[i];
      const nextDiff = diffs === null || diffs === void 0 ? void 0 : diffs[i + 1];
      const diffType = diff[0];
      const diffText = diff[1];
      const textLength = diffText.length;

      // text replacement
      if (diffType === -1 && nextDiff && nextDiff[0] === 1) {
        // TODO should probably update diff-match-patch to not include the spaces in diffs
        let shouldTrimEndingSpace = false;
        if (diffText.endsWith(' ') && nextDiff[1].endsWith(' ')) {
          shouldTrimEndingSpace = true;
        }

        // Count how many inline nodes are overlapping with the word correction, and cater for them
        const inlineNodeOverlapCount = paragraph.inlineNodePositions.filter(pos => paragraph.from + pos <= offset + textLength && paragraph.from + pos >= offset).length;
        const inlineNodeOffsetCount = paragraph.inlineNodePositions.filter(pos => paragraph.from + pos < offset).length;
        diffObjects.push({
          id: uuid(),
          from: 1 + offset + inlineNodeOffsetCount,
          to: (shouldTrimEndingSpace ? 0 : 1) + offset + textLength + inlineNodeOffsetCount - inlineNodeOverlapCount,
          type: 'REPLACEMENT',
          text: shouldTrimEndingSpace ? nextDiff[1].slice(0, -1) : nextDiff[1]
        });
        i++;
      }

      // unchanged and removed words are part of original text
      if (diffType === 0 || diffType === -1) {
        offset += textLength;
      }
    }
  });
  return diffObjects;
};

/**
 * @private
 * @deprecated - use getDiffObjectsBetweenParagraphs instead - below function
 * was from a quick spike and takes in promises which is not ideal
 */
export const getDiffObjects = (promises, paragraphs) => {
  const diffObjects = [];
  promises.forEach((promise, index) => {
    if (promise.status !== 'fulfilled') {
      return;
    }
    const paragraph = paragraphs[index];
    const a = DiffMatchPatch.diff_linesToWords_(paragraph.text, promise.value);
    let lineText1 = a.chars1;
    let lineText2 = a.chars2;
    let lineArray = a.lineArray;
    const diffs = DiffMatchPatch.diff_main(lineText1, lineText2, false);
    DiffMatchPatch.diff_charsToLines_(diffs, lineArray);
    let offset = paragraph.from;
    for (let i = 0; i < diffs.length; i++) {
      const diff = diffs[i];
      const nextDiff = diffs === null || diffs === void 0 ? void 0 : diffs[i + 1];
      const diffType = diff[0];
      const diffText = diff[1];
      const textLength = diffText.length;

      // text replacement
      if (diffType === -1 && nextDiff && nextDiff[0] === 1) {
        // TODO should probably update diff-match-patch to not include the spaces in diffs
        let shouldTrimEndingSpace = false;
        if (diffText.endsWith(' ') && nextDiff[1].endsWith(' ')) {
          shouldTrimEndingSpace = true;
        }

        // Count how many inline nodes are overlapping with the word correction, and cater for them
        const inlineNodeOverlapCount = paragraph.inlineNodePositions.filter(pos => paragraph.from + pos <= offset + textLength && paragraph.from + pos >= offset).length;
        const inlineNodeOffsetCount = paragraph.inlineNodePositions.filter(pos => paragraph.from + pos < offset).length;
        diffObjects.push({
          id: uuid(),
          from: 1 + offset + inlineNodeOffsetCount,
          to: (shouldTrimEndingSpace ? 0 : 1) + offset + textLength + inlineNodeOffsetCount - inlineNodeOverlapCount,
          type: 'REPLACEMENT',
          text: shouldTrimEndingSpace ? nextDiff[1].slice(0, -1) : nextDiff[1]
        });
        i++;
      }

      // unchanged and removed words are part of original text
      if (diffType === 0 || diffType === -1) {
        offset += textLength;
      }
    }
  });
  return diffObjects;
};